import { render } from "./CountryRisk.vue?vue&type=template&id=4644e1b3"
import script from "./CountryRisk.vue?vue&type=script&lang=js"
export * from "./CountryRisk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__